import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop — cosmetic browser quirk, not a real error
// Prevents it showing in both the console and the React dev error overlay
const RESIZE_OBSERVER_ERR = 'ResizeObserver loop completed with undelivered notifications.';

window.addEventListener('error', (e) => {
  if (e.message === RESIZE_OBSERVER_ERR) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
});

// Also suppress the React dev overlay (only active in development)
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message === RESIZE_OBSERVER_ERR) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// Patch the error handler that CRA uses for the overlay
const originalOnError = window.onerror;
window.onerror = (message, ...args) => {
  if (typeof message === 'string' && message.includes('ResizeObserver')) {
    return true; // suppress
  }
  return originalOnError?.call(window, message, ...args) ?? false;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  
    <App />
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();